// extracted by mini-css-extract-plugin
export default {"btn":"TextAreaAddMulti_btn__TjAZb","valuesContainer":"TextAreaAddMulti_valuesContainer__9XK1P","tag":"TextAreaAddMulti_tag__r-2Zu"};